import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { Menu, Home, FileText, LogOut, Users, MessageSquare } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

export default function NavigationMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const handleNavigation = (path) => {
    navigate(path);
    setOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  const navItems = user?.role === 'admin' ? [
    { path: '/admin', label: 'Dashboard Admin', icon: Home },
    { path: '/logs', label: 'Application Logs', icon: FileText },
  ] : [
    { path: '/dashboard', label: 'Kelola Chatbot', icon: MessageSquare },
    { path: '/logs', label: 'Application Logs', icon: FileText },
  ];

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className="border-2 hover:bg-blue-50 transition-all duration-200"
        >
          <Menu className="w-5 h-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[280px] sm:w-[320px]">
        <SheetHeader>
          <SheetTitle className="text-left">Menu Navigasi</SheetTitle>
          <div className="text-sm text-gray-600 text-left pt-2 border-t">
            {user?.email}
          </div>
        </SheetHeader>
        <div className="mt-6 space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <Button
                key={item.path}
                variant={isActive(item.path) ? "default" : "ghost"}
                className={`w-full justify-start transition-all duration-200 ${
                  isActive(item.path)
                    ? 'bg-blue-600 text-white hover:bg-blue-700'
                    : 'hover:bg-blue-50'
                }`}
                onClick={() => handleNavigation(item.path)}
              >
                <Icon className="w-4 h-4 mr-2" />
                {item.label}
              </Button>
            );
          })}
          
          <div className="pt-4 border-t">
            <Button
              variant="ghost"
              className="w-full justify-start text-red-600 hover:bg-red-50 hover:text-red-700 transition-all duration-200"
              onClick={() => {
                logout();
                setOpen(false);
              }}
            >
              <LogOut className="w-4 h-4 mr-2" />
              Keluar
            </Button>
          </div>
        </div>

        <div className="absolute bottom-6 left-6 right-6 text-xs text-gray-500 text-center">
          <div className="border-t pt-4">
            <p className="font-medium">
              {user?.role === 'admin' ? 'Admin Dashboard' : 'User Dashboard'}
            </p>
            <p className="text-gray-400 mt-1">v1.4.0</p>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
